// extracted by mini-css-extract-plugin
module.exports = {"content":"Imprint_content__-jT6W"};